var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFullscreen24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4.9a.9.9 0 0 1 .9-.9h4.2a.9.9 0 0 1 .9.9v4.2a.9.9 0 1 1-1.8 0V7.073l-3.664 3.663a.9.9 0 1 1-1.272-1.272L16.927 5.8H14.9a.9.9 0 0 1-.9-.9zm-3.264 8.364a.9.9 0 0 1 0 1.272L7.073 18.2h2.025a.9.9 0 1 1 0 1.8H4.9a.9.9 0 0 1-.9-.9v-4.2a.9.9 0 0 1 1.8 0v2.027l3.664-3.663a.9.9 0 0 1 1.272 0z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen24);
export default __webpack_public_path__ + "static/media/fullscreen_24.974049ac.svg";
export { ForwardRef as ReactComponent };